<template>
  <div class="c-memberEn">
    <div class="c-memberEn__photo">
      <div ref="c-memberEn__photoImg" v-for="(p, k) in photos" :style="`background-image: url(${p})`"></div>
    </div>
    <div class="c-memberEn__info f-ITC-BoldIt">
      <h2>{{member.name}}</h2>
      <h3>{{member.job}}</h3>
      <hr />
      <div class="c-memberEn__infoIntro" v-if="member.free_text">
        <p v-html="member.free_text"></p>
      </div>
      <div v-if="max > 1" class="c-memberEn__infoTool">
        <div ref="c-memberEn__infoTool__seek" class="c-memberEn__infoTool__seek">
          <ul>
            <li v-for="(p, k) in photos"></li>
          </ul>
        </div>
        <div class="c-memberEn__infoTool__prev" @click="change('prev')"><span></span></div>
        <div class="c-memberEn__infoTool__next" @click="change('next')"><span></span></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';
  import {gsap, TweenMax, Cubic} from 'gsap/all';

  export default {
    props: ['member'],
    data() {
      return {
        assets_path: assets_path,
        ispc: false,
        photos: [],
        seek: [],
        direction: 1,
        max: 0,
        current: 0,
        next: 0
      }
    },
    store,
    computed: {
    },
    created() {
    },
    mounted() {
      this.photos = [this.member.photo].concat(this.member.works);
      this.max = this.photos.length;

      this.$nextTick(this.start);
    },
    methods: {
      start() {
        this.seek = this.$refs['c-memberEn__infoTool__seek'].querySelectorAll('li');
        TweenMax.set(this.seek[this.current], {className: '+=isSelected'});
      },
      getNext(direction) {
        let next = 0;
        if (direction === 'prev') {
          next = this.current - 1;
          if (next < 0) next = this.max - 1;
        } else {
          next = (this.current + 1) % this.max;
        }
        return next;
      },
      change(direction) {
        const current = this.$refs['c-memberEn__photoImg'][this.current];
        const n = this.getNext(direction);
        const next = this.$refs['c-memberEn__photoImg'][n];

        console.log(this.seek[this.current]);
        TweenMax.set(this.seek[this.current], {className: ''});
        TweenMax.set(this.seek[n], {className: '+=isSelected'});

        let d = 1;
        if (direction === 'prev') {
          d = -1;
        }

        TweenMax.killTweensOf([current, next]);
        TweenMax.to(current, 0.7, {
          x: (-100 * d) + '%',
          ease: Cubic.easeOut
        });
        TweenMax.fromTo(next, 0.7, {
          visibility: 'visible',
          x: (100 * d) + '%'
        }, {
          x: '0%',
          ease: Cubic.easeOut,
          onComplete: this.showSlideComp
        });

        this.current = n;
      },
      showSlideComp() {

      }
    }
  }
</script>
